import React from 'react'

class StripeBG extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    const { bg2 } = this.props;

    // var colors = this.getColors();

    // if (bg2) colors.bg2 = bg2;

    return (
      <div className="stripes-container" style={{"background": "white"}}>
        <div id="stripes" style={{"background": "linear-gradient(150deg, #59708b 15%, #59708b 70%, #59708b 94%)"}}>
        </div>
      </div>
    )
  }

  getColors() {

    const { style } = this.props;

    if (style === "purple") {
      return {
        bg1: "linear-gradient(150deg, #7c07ff 15%, #7c07ff 70%, #7c07ff 94%)",
        bg2: "#8a2dff",
        color1: "#a636ff",
        color2: "#a036ff",
        color3: "#8439ff",
        color4: "#9831ff",
        color5: "#a12fff"
      }
    } else {
      return {
        bg1: "linear-gradient(150deg, #53f 15%, #05d5ff 70%, #a6ffcb 94%)",
        bg2: "#1bc3ff",
        color1: "#53f",
        color2: "#4553ff",
        color3: "#4f40ff",
        color4: "#0dcfff",
        color5: "#1fa2ff"
      }
    }

  }

}

export default StripeBG;



// WEBPACK FOOTER //
// ./src/components/Backgrounds/StripeBG.js